<div class="area" >
    <p-toast [style]="{width: '350px'}"></p-toast>
  
  <p-table
    dir="rtl"
    #dt1
    [value]="Eaps"
    selectionMode="single"
    [(selection)]="selectedType"
    (onRowSelect)="onRowSelect($event)"
    [paginator]="true"
    [rows]="10"
    >
    <ng-template pTemplate="header">
      <tr>
        <th [pSortableColumn]="'designation'"><p-sortIcon [field]="'designation'"></p-sortIcon> designation
          <button
            style="float: right; margin-top: 10px; margin-right: 10px"
            type="button"
            pButton
            icon="pi pi-plus"
            iconPos="right"
            (click)="showDialogToAdd()"
            label="اضافة نوع الدعاء "
        ></button>
        </th>
      </tr>
      <tr>
        <th>
          <input 
          style="width: 100%;" 
          pInputText type="text" 
          (input)="dt1.filter($event.target.value, 'designation', 'contains')" 
          [value]="dt1.filters['designation']?.value" 
          placeholder="designation" 
          class="p-column-filter">
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-Type>
      <tr
        [pSelectableRow]="Type"
        (mouseover)="changeText = Type.images"
        (mouseout)="changeText = false"
      >
        <td align="center">{{ Type.designation }}</td>
      </tr>
    </ng-template>
  </p-table> 
</div>
<p-dialog
  dir="rtl"
  header="نوع الدعاء"
  [(visible)]="displayDialog"
  [focusOnShow]="false"
  [responsive]="true"
  showEffect="fade"
  [modal]="true"
  [style]="{ width: '90%' }"
>
<div class="container">
  <div class="child">
    <span class="p-float-label">
      <input
        dir="rtl"
        id="designation"
        type="text"
        size="30"
        pInputText
        [(ngModel)]="Eap.designation"
        (click)="$event.target.select()" required
        style="text-align: center;"
      />
      <label htmlFor="designation">Désignation</label>
    </span>
  </div>
</div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button
        style="float: right; margin-top: 10px; margin-right: 10px"
        type="button"
        pButton
        icon="pi pi-sign-out"
        (click)="displayDialog=false"
        label="Fermer"
      ></button>
      <button
        type="button"
        style="float: left; margin-top: 10px; margin-right: 10px;background-color: red;"
        pButton
        class="ui-button-danger"
        icon="pi pi-times"
        (click)="delete()"
        label="Supprimer"
      ></button>
      <button
        style="float: right; margin-top: 10px; margin-right: 10px"
        type="button"
        pButton
        icon="pi pi-save"
        (click)="save()"
        label="Sauvegarder"
      ></button>
    </div>
  </p-footer>
</p-dialog>

